export default class Action {
  public click: Function = function(){};
  public text: string = '';
  public color: string = 'primary';
  public icon: string = '';

  constructor(
    click = function(){},
    text= '',
    color = 'primary',
    icon = '',
  ) {
  this.click = click;
  this.text = text;
  this.color = color;
  this.icon = icon;
  }
}
